import { replaceCdnAddress } from "@/utils/common";
import { buildI18nKeyValue } from "@/utils/common";
export default {
  data() {
    return {
      typeMaper: {
        4: 4, // 室内装饰
        3: 3, // 幕墙干挂
        2: 2, // 景观园林
        9: 9, // 景墙
        10: 10, // 商业空间
        11: 11, // 地铺应用
        12: 12, // 住宅空间
        13: 13 // 别墅庭院
      }
    };
  },
  computed: {
    localeColumns() {
      return this.$store.getters.localeColumns;
    }
  },
  methods: {
    buildForm() {
      return {
        name: { ...this.localeColumns },
        description: { ...this.localeColumns },
        country: { ...this.localeColumns },
        province: { ...this.localeColumns },
        city: { ...this.localeColumns },
        region: { ...this.localeColumns },
        street: { ...this.localeColumns },
        type_ids: [],
        product_ids: [],
        poster_image_url: "",
        poster_slogan: { ...this.localeColumns },
        cover_image_url: "",
        shooting_date: null,
        developer_id: null,
        designer_id: null,
        area_id: null,
        images: [
          // {
          //   url:"",
          //   seq:0
          // }
        ],
        vgc_engineering_case_id: null,
        seq: 1
      };
    },
    getAddressData(item, key) {
      if (item == null) {
        return "";
      }
      return item[key];
    },
    buildFormByVgcData(vgcItem) {
      let form = this.buildForm();
      form.name.cn = vgcItem.name;
      form.name.en = vgcItem.name;
      form.description.cn = vgcItem.description;
      form.description.en = vgcItem.description;
      form.country.cn = this.getAddressData(vgcItem.address, "country");
      form.country.en = this.getAddressData(vgcItem.address, "country");
      form.province.cn = this.getAddressData(vgcItem.address, "province");
      form.province.en = this.getAddressData(vgcItem.address, "province");
      form.city.cn = this.getAddressData(vgcItem.address, "city");
      form.city.en = this.getAddressData(vgcItem.address, "city");
      form.region.cn = this.getAddressData(vgcItem.address, "region");
      form.region.en = this.getAddressData(vgcItem.address, "region");
      form.street.cn = this.getAddressData(vgcItem.address, "street");
      form.street.en = this.getAddressData(vgcItem.address, "street");
      form.area_id = vgcItem.areaId;
      form.product_ids = vgcItem.products.map(elData => elData.id);
      form.type_ids = vgcItem.types.map(elData => elData.id);
      form.images = vgcItem.images.map(elData => {
        return {
          url: replaceCdnAddress(elData.url),
          seq: elData.seq
        };
      });
      form.shooting_date = vgcItem.shootingDate;
      form.developer_id = vgcItem.developerId == 50 ? 1 : vgcItem.developerId;
      form.designer_id = vgcItem.designerId;
      form.poster_image_url = replaceCdnAddress(vgcItem.posterImageUrl);
      form.poster_slogan.cn = vgcItem.posterSlogan;
      form.poster_slogan.en = vgcItem.posterSlogan;
      form.cover_image_url = replaceCdnAddress(vgcItem.coverImageUrl);
      form.vgc_engineering_case_id = vgcItem.id;
      form.seq = 1;
      return form;
    },
    buildEditFormData(caseData) {
      if (!caseData) {
        return;
      }
      let form = this.buildForm();
      for (const key in form) {
        if (Object.hasOwnProperty.call(caseData, key)) {
          form[key] = caseData[key];
        }
      }
      form.name = buildI18nKeyValue(caseData.name);
      form.description = buildI18nKeyValue(caseData.description);
      form.country = buildI18nKeyValue(caseData.country);
      form.province = buildI18nKeyValue(caseData.province);
      form.city = buildI18nKeyValue(caseData.city);
      form.region = buildI18nKeyValue(caseData.region);
      form.street = buildI18nKeyValue(caseData.street);
      form.poster_slogan = buildI18nKeyValue(caseData.poster_slogan);
      form.vgc_engineering_case_id = caseData.vgc_engineering_case_id;
      form.type_ids = caseData.types.map(item => item.id);
      form.product_ids = caseData.products.map(item => item.id);
      return form;
    }
  }
};
